<template>
  <div>
    <PageTitle title="Ledger Type" />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-btn :ripple="false" class="min-button" icon @click="show = !show">
          <v-icon color="blue" class="ml-10">
            {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
          </v-icon>
          <span class="subheading filterclor">Filter</span>
        </v-btn>
        <v-expand-transition>
          <v-card class="lighten-12 card-content mb-2" v-show="show">
            <v-row class="ma-0 align-right">
              <TableFilters
                :filters="['status', 'search']"
                v-model="filter"
                :columns="columns"
                :msgs="'Name'"
              ></TableFilters>
            </v-row>
          </v-card>
        </v-expand-transition>

        <LoadingComponent
          v-if="isLoading"
          :visible="isLoading"
        ></LoadingComponent>
        <v-card class="lighten-12 mt-2">
          <v-container fluid class="light gray lighten-12">
            <v-row>
              <v-card-text class="pa-0">
                <v-data-table
                  class="ledger-txt"
                  :items-per-page="paginationOptions.perPage"
                  :fixed-header="true"
                  :headers="headers"
                  :single-expand="singleExpand"
                  :items="units"
                  item-key="id"
                  hide-default-footer
                >
                  <template v-slot:no-data>
                    <noData
                      class="mt-10 container justify-center item-center"
                      name="ledger type"
                    />
                  </template>

                  <!-- No -->
                  <template v-slot:item.no>
                    <v-icon>mdi-vuetify</v-icon>
                  </template>
                  <!-- Name -->
                  <template v-slot:item.name="{ item }"
                    ><ValidationProvider
                      v-slot="{ errors }"
                      name="Name"
                      vid="name"
                      v-if="item.id == editLedgetId"
                    >
                      <v-text-field
                        v-model="ledgertype.name"
                        :error-messages="errors"
                        :value="item.name"
                        outlined
                        class="pt-3"
                      ></v-text-field>
                    </ValidationProvider>
                    <p v-else>{{ item.name }}</p>
                  </template>

                  <template v-slot:item.created_at="{ item }">
                    {{
                      item.created_at
                        ? item.created_at
                        : '---------' | formatDate
                    }}
                  </template>

                  <!-- Name -->

                  <!-- Status -->
                  <template v-slot:item.status="{ item }" :slot-scope="props">
                    <toggle-button
                      v-model="ledgertype.is_active"
                      v-if="editLedgetId == item.id"
                      :disabled="editLedgetId != item.id"
                      :value="item.is_active"
                      :width="80"
                      :labels="{ checked: 'Active', unchecked: 'Archeived' }"
                    ></toggle-button>
                    <v-chip
                      v-else
                      :x-small="true"
                      class="ma-2"
                      label
                      text-color="white"
                      :color="getStatusColor(item.is_active)"
                      dark
                      >{{ item.is_active ? 'Active' : 'Archived' }}</v-chip
                    >
                  </template>

                  <!-- Action -->
                  <template v-slot:item.action="{ item }">
                    <v-menu offset-y transition="scroll-y-transition">
                      <template v-slot:activator="{ $attrs, on }">
                        <v-icon
                          v-show="editLedgetId != item.id"
                          v-bind="$attrs"
                          v-on="on"
                          >mdi-dots-vertical</v-icon
                        >
                        <v-btn
                          v-show="editLedgetId == item.id"
                          color="secondary"
                          fab
                          x-small
                          dark
                          class="ma-1"
                        >
                          <v-icon
                            depressed
                            small
                            link
                            @click="CancelLedger(item)"
                            >clear</v-icon
                          ></v-btn
                        >
                        <v-btn
                          v-show="editLedgetId == item.id"
                          color="green"
                          fab
                          x-small
                          dark
                          ><v-icon link @click="UpdateLedger(item)"
                            >done</v-icon
                          ></v-btn
                        >
                      </template>

                      <v-list class="actions">
                        <permission-control permissionName="Ledger Type Edit">
                          <v-list-item link @click="EditLedger(item)">
                            <span>
                              <v-icon v-bind="$attrs" v-on="on"
                                >mdi-pencil-box-outline</v-icon
                              >Edit
                            </span>
                          </v-list-item>
                        </permission-control>
                        <permission-control
                          permissionName="Ledger Type Soft Delete"
                        >
                          <v-list-item link @click="openConfirmation(item)">
                            <span>
                              <v-icon v-bind="$attrs" v-on="on">
                                {{
                                  item.is_active
                                    ? 'mdi-archive'
                                    : 'mdi-checkbox-marked-circle'
                                }}
                              </v-icon>
                              {{ item.is_active ? 'Archieve' : 'Active' }}
                            </span>
                          </v-list-item>
                        </permission-control>
                      </v-list>
                    </v-menu>
                  </template>
                  <template v-slot:footer>
                    <pagination
                      @paginationOptions="setPaginationOptions"
                      @response="setResponseData"
                      @getPageNumber="setPagenumber"
                      url="ledger-types"
                      :filterAction="true"
                      :filter="filter"
                      ref="pagination"
                    >
                    </pagination>
                  </template>

                  <template slot="body.append">
                    <v-row v-if="editLedgetId == null">
                      <v-col cols="5">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="name"
                          vid="name"
                          rules="required"
                        >
                          <v-text-field
                            :error-messages="errors"
                            required
                            dense
                            label="Name"
                            v-model="ledgertype.name"
                            outlined
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="2">
                        <permission-control permissionName="Ledger Type Create">
                          <v-btn
                            @click="SaveLedger()"
                            depressed
                            small
                            class="text-white btn_blue btn_medium w-100"
                            :disabled="!ledgertype.name"
                            >Create</v-btn
                          >
                        </permission-control>
                      </v-col>
                    </v-row>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-row>
          </v-container>
        </v-card>
      </ValidationObserver>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>
<script>
import axios from '@/plugins/axios';
import TableFilters from '@/components/base/TableFilters';

import { required, email, max, regex } from 'vee-validate/dist/rules';
import { mapState } from 'vuex';
import pagination from '../../components/pagination';
import confirmation from '../../components/confirmation';
import noData from '../../../../components/shared/noItem';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('regex', {
  ...regex,
  message: 'The value is not a valid phone number',
});
export default {
  components: {
    pagination,
    ValidationProvider,
    TableFilters,
    ValidationObserver,
    noData,
  },
  data() {
    return {
      show: false,
      on: {
        click: console.log,
        contextmenu: console.log,
      },
      inheritAttrs: false,
      paginationOptions: {},
      isLoading: false,
      singleExpand: false,
      pagination1: {
        descending: true,
        page: 1,
        rowsPerPage: 2,
        sortBy: 'fat',
        totalItems: 0,
        unitErrors: null,
        rowsPerPageItems: [1, 2, 4, 8, 16],
      },
      units: [],
      pagination: {
        page: 1,
        itemsPerPage: 2,
      },
      page: 1,
      status: [
        { text: 'Active', value: 'active' },
        { text: 'Archived', value: 'archived' },
      ],
      columns: [
        {
          text: 'Name',
          value: 'name',
          show: true,
          disabled: false,

          align: 'left',
        },
        {
          text: 'Date',
          value: 'created_at',
          show: true,
          disabled: false,

          align: 'left',
        },
        {
          text: 'Status',
          value: 'status',
          show: true,
          disabled: false,
          align: 'center',
        },
        {
          text: 'Actions',
          value: 'action',
          show: true,
          disabled: false,
          align: 'center',
        },
      ],
      ledgertype: { name: '', id: '', is_active: '' },
      filter: {
        name: '',
        search: '',
        status: '',
      },

      // For edit purpose
      editLedgetId: null,
    };
  },
  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    setResponseData(unit) {
      this.units = unit;
    },

    CancelLedger(item) {
      this.refreshData();
      this.editLedgetId = null;
      this.ledgertype = {};
    },
    SaveLedger() {
      const isValid = this.$refs.observer.validate();
      if (isValid) {
        this.isLoading = true;
        this.CreateLedger();
      }
    },

    CreateLedger() {
      let ledgername = this.ledgertype;
      delete ledgername.id;
      delete ledgername.is_active;

      this.isLoading = true; // Start loading spinner

      axios
        .post('ledger-types', ledgername)
        .then((res) => {
          this.$toast.success('Ledger type created successfully');
          this.refreshData();
          this.$refs.observer.reset(); // Clear validation errors
          this.ledgertype = {}; // Reset form
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.error) {
            this.$refs.observer.setErrors(err.response.data.error); // Set field errors
          }

          this.$toast.error(
            err.response?.data?.title || 'Failed to create ledger type',
          );
          this.messages = err.response?.data?.title || '';
        })
        .finally(() => {
          this.isLoading = false; // Always stop loading
        });
    },

    UpdateLedger(data) {
      let Ledger = _.cloneDeep(data);
      let ID = Ledger.id;

      delete Ledger.created_at;
      delete Ledger.id;
      delete Ledger.updated_at;
      delete Ledger.deleted_at;
      delete Ledger.is_active;

      this.isLoading = true; // Start loading spinner

      axios
        .patch(`ledger-types/${ID}`, Ledger)
        .then((res) => {
          this.editLedgetId = null;
          this.ledgertype = {};
          this.$toast.success('Ledger type edited successfully');
          this.$refs.observer.reset();
          this.refreshData();
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.error) {
            this.$refs.observer.setErrors(err.response.data.error);
          }

          this.$toast.error(
            err.response?.data?.title || 'Failed to edit ledger type',
          );
          this.messages = err.response?.data?.title || '';
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    EditLedger(data) {
      this.ledgertype = data;
      this.editLedgetId = data.id;
    },
    getStatusColor(is_active) {
      return is_active ? 'green' : 'gray';
    },
    openConfirmation(Ledger) {
      confirmation.dialog = true;

      this.$confirm(
        'Do you want to ' +
          (Ledger.is_active ? 'Archive ' : 'Active ') +
          Ledger.name +
          ' ?',
      ).then((res) => {
        if (res) {
          axios
            .get(`ledger-types/${Ledger.id}/soft-delete`)
            .then((res) => {
              this.refreshData();
              const msg = Ledger.is_active ? 'archived' : 'activated';
              this.$toast.success('Successfully ' + msg);
            })
            .catch((err) => {
              this.$toast.error('Ledger type is not archived');
            });
        } else {
        }
      });
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    //   this.GetUnits();
    // this.refreshData();
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

.ledger-txt {
  /* font-weight: bold; */
  font-family: 'Source Sans Pro', sans-serif;
}
.min-button::before {
  display: none;
}
</style>
